import React, { useEffect, useState, useMemo } from 'react';
import apis from '../../../../apis';
import { message, Empty } from '@drip/drip-design';
import './index.less';
import utils from '@/common/utils';
import { Chart, Axis, Tooltip, Interval, Interaction, Coordinate } from 'bizcharts';
import ScrollX from '@/components/scroll-x';
import IconTip from '@/components/icon-tip';

export default function (props) {
  const [data, setData] = useState({});
  useEffect(() => {
    if (!props.conditions.planCode || props.conditions.realTimeData) return;
    apis.queryShoppingInfoList({ ...props.conditions }).then((res) => {
      const { ret, data, msg } = res;
      if (ret === '0') {
        setData(data);
      } else {
        message.error(msg);
        setData({});
      }
    });
  }, [props.conditions]);

  const scale = {
    rate: {
      formatter: (val) => {
        return utils.formatPriceWithPercent(val * 100) + '%';
      },
      alias: '比例',
    },
  };
  const getChart = (data) => {
    return (
      <Chart
        height={340}
        data={data}
        scale={scale}
        interactions={['element-active']}
        autoFit
        padding={[10, 20, 20, 20]}
      >
        <Coordinate type="theta" radius={0.5} />
        <Tooltip showTitle={false} />
        <Axis visible={false} />
        <Interval
          position="rate"
          adjust="stack"
          color="name"
          label={[
            'name',
            (item) => {
              return {
                offset: 30,
                content: (data) => {
                  return `${data.name} ${utils.formatPriceWithPercent(data.rate * 100)}%`;
                },
              };
            },
          ]}
        />
      </Chart>
    );
  };

  const shoppingData = useMemo(() => {
    const cateList = data.cfvCateCate1 ? data.cfvCateCate1.slice(0, 20) : [];
    return (
      <>
        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
          <div style={{ flex: '1', marginRight: '16px' }}>
            <div className="user-analysis-user-shopping-card">
              {data.cgpCustPurchpower && (
                <>
                  <div className="user-analysis-user-shopping-title">
                    购买力分布：以【{data.cgpCustPurchpower[0].name}】居多
                    <IconTip
                      title={
                        <ul style={{ paddingLeft: 20, paddingTop: 10, paddingRight: 6 }}>
                          <li>土豪：经常买奢侈品和高端商品；</li>
                          <li>高级白领：生活品质较高，会偶尔高一些高端商品；</li>
                          <li>小白领：生活品质还不错，但是闲钱不多，喜欢买一些中端商品；</li>
                          <li>蓝领：生活品质一般，更倾向于购买中低端商品；</li>
                          <li>收入很少：量入为出，喜欢买经济实惠的东西，从不买高端商品</li>
                        </ul>
                      }
                      type="question"
                      size="small"
                    />
                  </div>
                  {getChart(data.cgpCustPurchpower)}
                </>
              )}
            </div>
          </div>
          <div style={{ flex: '1', marginRight: '16px' }}>
            <div className="user-analysis-user-shopping-card">
              {data.jxzScore && (
                <>
                  <div className="user-analysis-user-shopping-title">
                    京享值分布：主要集中在【{data.jxzScore[0].name}】区间
                  </div>
                  {getChart(data.jxzScore)}
                </>
              )}
            </div>
          </div>
          <div style={{ flex: '1' }}>
            <div className="user-analysis-user-shopping-card">
              {data.sinkScore && (
                <>
                  <div className="user-analysis-user-shopping-title">
                    下沉值分布：以【{data.sinkScore[0].name}】用户为主
                    <IconTip
                      title="下沉人群主要包括3-6线城市及乡镇生活的高收入人群及普通居民，加上部分生活在一二线城市的低收入人群"
                      type="question"
                      size="small"
                    />
                  </div>
                  {getChart(data.sinkScore)}
                </>
              )}
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
          <div style={{ flex: '1', marginRight: '16px' }}>
            <div className="user-analysis-user-shopping-card">
              {cateList.length && (
                <>
                  <div className="user-analysis-user-shopping-title">
                    品类购买排行：用户购买最多的一级品类集中在【{cateList[0].name}】
                  </div>
                  {getChart(cateList)}
                </>
              )}
            </div>
          </div>
          <div style={{ flex: '1', marginRight: '16px' }}>
            <div className="user-analysis-user-shopping-card">
              {data.csfSaleRebuyLasty && (
                <>
                  <div className="user-analysis-user-shopping-title">
                    新老用户分布：用户购物历史为【{data.csfSaleRebuyLasty[0].name}】居多
                    <IconTip
                      title={
                        <>
                          根据订单订购日期来判断：
                          1-当用户“最晚销售订单订购日期=最早销售订单订购日期”，并且“最晚销售订单订购日期”是去年时，判定该用户为去年首次购；
                          2-当用户“最晚销售订单订购日期&gt;最早销售订单订购日期”，并且“最晚销售订单订购日期”是去年时，判断该用户为去年复购;
                          3-如果“最晚销售订单订购日期”&le;去年，则为&lsquo;去年无购买&rsquo;;
                          4-其他情况都是&lsquo;去年之前无购买&rsquo;
                        </>
                      }
                      type="question"
                      size="small"
                    />
                  </div>
                  {getChart(data.csfSaleRebuyLasty.slice(0, 20))}
                </>
              )}
            </div>
          </div>
          <div style={{ flex: '1' }}>
            <div className="user-analysis-user-shopping-card">
              {data.isPlus && (
                <>
                  <div className="user-analysis-user-shopping-title">PLUS会员分布：以【{data.isPlus[0].name}】为主</div>
                  {getChart(data.isPlus)}
                </>
              )}
            </div>
          </div>
        </div>
      </>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <div>
      {Object.keys(data).length !== 0 ? (
        <>{shoppingData}</>
      ) : (
        <div className="user-analysis-user-shopping-card">
          <Empty description="暂无数据" />
        </div>
      )}
    </div>
  );
}
